module.exports = __webpack_public_path__ + "img/spring-air-aviation.220f1dff.jpg";